import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {Supplier} from '../../../Models/Supplier';
import {BehaviorSubject, concat, Observable, of, Subject} from 'rxjs';
import {Router} from '@angular/router';
import {SupplierService} from '../../../Services/supplier.service';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';

@Component({
  selector: 'app-archive-supplier-view',
  templateUrl: './archive-supplier-view.component.html',
  styleUrls: ['./archive-supplier-view.component.scss']
})
export class ArchiveSupplierViewComponent implements OnInit {

  public grid: Grid;
  public supplierId: number;
  public supplierName: string;
  public suppliers: Observable<Supplier[]>;
  public refreshGrid = new BehaviorSubject(1);
  @ViewChild('supplierRowDetail', {static: false}) supplierRowDetail: any;
  @ViewChild('readdModel', {static: false}) readdModel = null;
  constructor(private router: Router, private supplierService: SupplierService, private translate: TranslateService,
              private broadcastService: BroadcastService) { }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.supplier.number',
          prop: 'number',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.supplier.companyName',
          prop: 'companyName',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.supplier.email',
          prop: 'email',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.supplier.phone',
          prop: 'phone',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.supplier.status',
          prop: 'status',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            if (row) {
              return this.translate.instant(Supplier.SUPPLIER_STATUS_ACTIVE);
            }
            return this.translate.instant(Supplier.SUPPLIER_STATUS_INACTIVE);
          }
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-plus',
              tooltip: 'global.readd',
              onclick: row => {
                this.supplierId = row.id;
                this.supplierName = row.companyName.bold();
                this.readdModel.show();
                // return this.router.navigateByUrl('back-office/supplier/' + row.id + '/show');
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        }
      ],
      service: this.supplierService,
      rememberURL: this.router.url,
      method: 'getSupplier',
      defaultSort: 'name',
      rowDetailTemplate: this.supplierRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      archive: true,
    };
  }


  reAdd() {
    this.supplierService.reAdd(this.supplierId).subscribe((res) => {
      this.broadcastService.broadcast('refreshGrid', 'getSupplier');
      this.readdModel.hide();
    });
  }

}
